import ClientContractsPageGroup from 'source/pages/root/InvoicePageGroup.vue';

export default [{
    path: 'client-contracts',
    component: ClientContractsPageGroup,
    meta: {
        title: 'Client Contracts - HQZen',
        canDisplayGlobalModals: true
    },
    children: [
        {
            path: '',
            name: 'client-contracts',
            component: () => import('src/pages/client/ClientContractsPage.vue'),
            meta: {
                title: 'Contracts - HQZen',
                canDisplayGlobalModals: true,
                isInternal: true
            }
        },
    ]
}];
